import { Link } from 'react-router-dom';

interface Props {
  facebookUrl: string;
}

export default function WhyJoin({ facebookUrl }: Props) {
  return (
    <section className="py-20 bg-[#fafafa]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main message */}
        <div className="text-center mb-14">
          <span className="text-xs font-bold tracking-widest uppercase text-rose-500 mb-5 block">The Real Pitch</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-5 leading-snug">
            &ldquo;If you&apos;re already coming to events,<br />
            <span className="text-rose-500">this just makes your life easier.&rdquo;</span>
          </h2>
          <p className="text-gray-500 text-base leading-relaxed max-w-xl mx-auto">
            VIP isn&apos;t about adding more to your plate. It&apos;s about removing friction from the things you&apos;re already doing.
          </p>
        </div>

        {/* Three-column comparison */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
          <div className="bg-white border border-gray-100 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-xl mx-auto mb-4">
              <i className="ri-time-line text-gray-500 text-xl"></i>
            </div>
            <h3 className="text-base font-extrabold text-gray-900 mb-2">Without VIP</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              You check the event page. It&apos;s full. Again. You missed it because you waited.
            </p>
          </div>
          <div className="bg-rose-500 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mx-auto mb-4">
              <i className="ri-vip-crown-fill text-white text-xl"></i>
            </div>
            <h3 className="text-base font-extrabold text-white mb-2">With VIP</h3>
            <p className="text-sm text-white/80 leading-relaxed">
              You got the notification 48 hours early. You RSVPed before it went public. You&apos;re in.
            </p>
          </div>
          <div className="bg-white border border-gray-100 rounded-2xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-rose-50 rounded-xl mx-auto mb-4">
              <i className="ri-heart-fill text-rose-500 text-xl"></i>
            </div>
            <h3 className="text-base font-extrabold text-gray-900 mb-2">The Difference</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              $12/month to stop missing out on the things you actually want to do.
            </p>
          </div>
        </div>

        {/* Social proof bar */}
        <div className="bg-white border border-gray-100 rounded-2xl px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-5">
            <div className="flex -space-x-2">
              {['memv1', 'memv2', 'memv3', 'memv4'].map((seq) => (
                <div key={seq} className="w-10 h-10 rounded-full border-2 border-white overflow-hidden shrink-0">
                  <img
                    src={`https://public.readdy.ai/ai/img_res/dd5228c0354aac6a34ece0d830a49d6e.jpg${seq}&orientation=squarish`}
                    alt="Member"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              ))}
            </div>
            <div>
              <p className="text-sm font-bold text-gray-900">3,000+ local moms inside TMM</p>
              <p className="text-xs text-gray-400">Gwinnett and surrounding areas</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/events"
              className="px-5 py-2.5 border border-gray-200 text-gray-700 text-sm font-bold rounded-xl hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              Browse Events
            </Link>
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 bg-rose-500 hover:bg-rose-600 text-white text-sm font-bold rounded-xl transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              Get VIP Access
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
